export default {

    methods: {
        priceCalculation: function(deadline, quality) {
            var a_price = [];
            //12 hours, High school
            a_price['1_1'] = 26;
            //1 days, High school
            a_price['2_1'] = 24;
            //2 days, High school
            a_price['3_1'] = 22;
            //3 days, High school
            a_price['4_1'] = 20;
            //5 days, High school
            a_price['5_1'] = 18;
            //7 days, High school
            a_price['6_1'] = 16;
            //14 days, High school
            a_price['7_1'] = 12;

            //12 hours, College
            a_price['1_2'] = 28;
            //1 day, College
            a_price['2_2'] = 26;
            //2 days, College
            a_price['3_2'] = 24;
            //3 days, College
            a_price['4_2'] = 22;
            //5 days, College
            a_price['5_2'] = 20;
            //7 days, College
            a_price['6_2'] = 18;
            //14 days, College
            a_price['7_2'] = 16;

            //12 hours, University
            a_price['1_3'] = 32;
            a_price['2_3'] = 30;
            a_price['3_3'] = 28;
            a_price['4_3'] = 26;
            a_price['5_3'] = 24;
            a_price['6_3'] = 22;
            a_price['7_3'] = 20;

            //12 hours, Masters
            a_price['1_4'] = 36;
            a_price['2_4'] = 34;
            a_price['3_4'] = 32;
            a_price['4_4'] = 30;
            a_price['5_4'] = 28;
            a_price['6_4'] = 26;
            a_price['7_4'] = 24;

            //12 hours, PhD
            a_price['1_5'] = 42;
            a_price['2_5'] = 40;
            a_price['3_5'] = 38;
            a_price['4_5'] = 36;
            a_price['5_5'] = 34;
            a_price['6_5'] = 32;
            a_price['7_5'] = 30;

            return a_price[deadline+'_'+quality]
        },

        calculateDefaultWriterPricePerPage: function(deadline, quality) {
            var a_price = [];
            var a_price = [];
            a_price['1_1'] = 6.5;
            a_price['2_1'] = 6;
            a_price['3_1'] = 5.5;
            a_price['4_1'] = 4.5;
            a_price['5_1'] = 4;
            a_price['6_1'] = 4;
            a_price['7_1'] = 4;

            a_price['1_2'] = 7;
            a_price['2_2'] = 6.5;
            a_price['3_2'] = 6;
            a_price['4_2'] = 5;
            a_price['5_2'] = 5;
            a_price['6_2'] = 5;
            a_price['7_2'] = 5;

            a_price['1_3'] = 8;
            a_price['2_3'] = 7;
            a_price['3_3'] = 6.5;
            a_price['4_3'] = 6;
            a_price['5_3'] = 6;
            a_price['6_3'] = 5.5;
            a_price['7_3'] = 5.5;

            a_price['1_4'] = 9;
            a_price['2_4'] = 8;
            a_price['3_4'] = 7;
            a_price['4_4'] = 6.5;
            a_price['5_4'] = 6.5;
            a_price['6_4'] = 6;
            a_price['7_4'] = 6;

            a_price['1_5'] = 10;
            a_price['2_5'] = 9;
            a_price['3_5'] = 8;
            a_price['4_5'] = 7;
            a_price['5_5'] = 7;
            a_price['6_5'] = 6.5;
            a_price['7_5'] = 6.5;

            return a_price[deadline+'_'+quality]
        }

    },

}